module.exports = __webpack_public_path__ + "img/Asher.170aaeac.jpeg";